import './ShareProjectRemoveModal.scss';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'src/modules/common/components/Button';
import { ModalBody } from 'src/modules/common/components/ModalBody';
import { ModalFooter } from 'src/modules/common/components/ModalFooter';
import { ModalHeader } from 'src/modules/common/components/ModalHeader';
import { ProjectRole } from 'src/modules/common/types/ProjectRole';
import { SharedUser } from 'src/modules/sharing-projects/types/SharedUser';

type Props = {
  readonly user: SharedUser;
  readonly role: ProjectRole;
  readonly submitting: boolean;

  readonly onSubmit: (data: {
    user: SharedUser;
    role: ProjectRole;
  },) => void;
  readonly onCancel: () => void;
};

export const ShareProjectChangeOwnRoleModal = ({
  user,
  role,
  submitting,
  onSubmit,
  onCancel,
}: Props): React.ReactElement => {
  const intl = useIntl();

  return (
    <>
      <ModalHeader
        title={<FormattedMessage id="shareProject/roleModal/title" values={{ role }}/>}
        handleClose={onCancel}
        danger={true}
      />

      <ModalBody danger={true}>
        <div className="bp-share-project-remove-modal__body">
          <FormattedMessage
            id="shareProject/roleModal/body"
            values={{
              firstName: user.firstName,
              lastName: user.lastName,
              role: role,
            }}
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          kind="secondary"
          fullWidth={true}
          onClick={onCancel}
          autoFocus={true}
          disabled={submitting}
        >
          <FormattedMessage id="shareProject/roleModal/action/cancel"/>
        </Button>

        <Button
          disabled={submitting}
          kind="danger"
          fullWidth={true}
          onClick={() => onSubmit({ user, role })}
          loading={submitting}
        >
          <FormattedMessage id="shareProject/roleModal/action/submit"/>
        </Button>
      </ModalFooter>
    </>
  );
};
